export default __webpack_public_path__ + "static/media/first.e5ce8f67.png";